export const MEAL = '/meal/' as const
export const MEAL_ALL = `${MEAL}all` as const
export const MEAL_ACTIVATION = '/meal-activation/' as const
export const MEAL_ACTIVATION_ALL = `${MEAL_ACTIVATION}all` as const
export const MEAL_ACTIVATION_STATUS = `${MEAL_ACTIVATION}status` as const
